import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=0470e98a&"
import script from "./CreateAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0470e98a')) {
      api.createRecord('0470e98a', component.options)
    } else {
      api.reload('0470e98a', component.options)
    }
    module.hot.accept("./CreateAccount.vue?vue&type=template&id=0470e98a&", function () {
      api.rerender('0470e98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/Modals/CreateAccount.vue"
export default component.exports